<template>
  <div class="container-fluid mtb15 no-fluid">
    <div  class="modal" id="myModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Special Welcome Bonus - Up to 50% on First Deposit</h5>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"></button> -->
          </div>
          <div class="modal-body">
            We are currently running a special promotion offering new users a welcome bonus of up to 50% on their first
            deposit. Single deposits under 50k will receive a 20% welcome bonus, deposits between 50k and 100k will
            receive a 30% welcome bonus, and single deposits over 100k will receive a 50% welcome bonus. This bonus can
            be used for trading and earning profits, presenting an excellent opportunity to enhance your account's
            trading capacity.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
          </div>

        </div>
      </div>
    </div>
    <div class="row sm-gutters">
      <!-- 小屏幕下的切换按钮 -->
      <div class="col-12 d-md-none mb-3">
        <button
          class="btn btn-primary w-100 d-flex justify-content-between align-items-center"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#marketPairsCanvas"
        >
          Market Pairs
          <i class="icon ion-md-menu"></i>
        </button>
      </div>

      <!-- MarketPairs 在小屏时的抽屉 -->
      <div
        class="offcanvas offcanvas-start"
        tabindex="-1"
        id="marketPairsCanvas"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title">Market Pairs</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body p-0">
          <MarketPairs :biList="biList" @bi-selected="handleBiSelected" />
        </div>
      </div>

      <!-- MarketPairs 在大屏时的显示 -->
      <div class="col-sm-12 col-md-3 d-none d-md-block">
        <MarketPairs :biList="biList" @bi-selected="handleBiSelected" />
      </div>

      <div class="col-sm-12 col-md-6">
        <!-- <TradingChart v-if="$store.state.theme" />
        <TradingChartDark v-else /> -->
        <KlineChart v-if="selectedBi" :bi="selectedBi" ref="chart" />
      </div>
      <div class="col-md-3">
        <MarketTrade
          v-if="selectedBi"
          :biList="biList"
          :bi="selectedBi"
          ref="trade"
        />
      </div>
      <div class="col-md-12" v-if="$store.state.isLogin">
        <HistoryOrder :biList="biList" @chooseBiById="chooseBiById" />
      </div>
    </div>
  </div>
  <!-- <AnnouncementModel></AnnouncementModel> -->
</template>

<script>
const bootstrap = require("bootstrap");
import createWebSocket from "@/utils/websocket";
import MarketPairs from "../components/MarketPairs.vue";
import MarketTrade from "../components/MarketTrade.vue";
import HistoryOrder from "../components/HistoryOrder.vue";
// import TradingChart from "../components/TradingChart.vue";
// import TradingChartDark from "../components/TradingChartDark.vue";
import KlineChart from "../components/klinechart.vue";
// import AnnouncementModel from "../components/AnnouncementModel.vue";
import {Modal} from 'bootstrap';
export default {
  components: {
    MarketPairs,
    MarketTrade,
    HistoryOrder,
    // TradingChart,
    // TradingChartDark,
    KlineChart,
    // AnnouncementModel,
  },
  data() {
    return {
      biList: [],
      selectedBi: null,
    };
  },
  created() {
    this.ws = createWebSocket((data) => {
      // console.log(data);
      if (data.ch == "sub.bizhong@list") {
        const list = [];
        // 转成数组
        for (const key in data.data) {
          list.push(data.data[key]);
        }
        this.biList = list;
        if (!this.selectedBi) {
          this.selectedBi = list[0];
        }
      }
    });
  },
  beforeUnmount() {
    this.ws.close();
  },
  mounted() {
    let myModal = new Modal(document.getElementById('myModal'));
    //myModal.show();
  },
  beforeRouteLeave(to, from, next) {
    // 关闭模态框
    this.closeModal();
    next();
  },
  methods: {
    closeModal() {
      // 假设你使用的是 Bootstrap 的模态框
      const modal = document.getElementById('myModal');
      if (modal) {
        // 使用 Bootstrap 的方法关闭模态框
        bootstrap.Modal.getInstance(modal).hide();
      }
    },
    handleBiSelected(bi) {
      this.selectedBi = bi;
      // 在小屏幕下选择交易对后关闭抽屉
      const offcanvas = document.getElementById("marketPairsCanvas");
      if (offcanvas) {
        const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvas);
        if (bsOffcanvas) {
          bsOffcanvas.hide();
        }
      }
    },
    chooseBiById(bi_id, type) {
      console.log(this.$refs)
      this.$refs[type]?.$el?.scrollIntoView();
      const find = this.biList.find((bi) => bi.bi_id === bi_id);
      if (find) {
        this.selectedBi = find;
      }
    },
  },
};
</script>

<style scoped>
/* 确保抽屉在小屏幕下有合适的宽度 */
.offcanvas {
  width: 320px;
}

/* 抽屉样式 */
.offcanvas-header {
  padding: 1rem;
  background: var(--light);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.dark .offcanvas-header {
  background: #1e2126;
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.dark .offcanvas {
  background-color: #1e2126;
  color: #fff;
}

/* 切换按钮样式 */
.btn-primary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
}

.btn-primary i {
  font-size: 1.25rem;
}

/* 移除抽屉内容的内边距，让 MarketPairs 组件占满空间 */
.offcanvas-body {
  padding: 0;
  height: calc(100% - 56px); /* 减去 header 的高度 */
  overflow-y: auto;
}

/* 确保主内容区域可以滚动 */
.container-fluid {
  min-height: 100vh;
  overflow-y: auto;
}

/* 确保行高度自适应 */
.row {
  min-height: calc(100vh - 30px); /* 减去 mtb15 的上下边距 */
}
</style>
